import * as api from "../api";

export const getBogies = () => async (dispatch) => {
  try {
    const { data } = await api.fetchBogies();
    dispatch({ type: "FETCH_BOGIES", payload: data });
  } catch (error) {
    console.error(error);
  }
};

export const addBogie = (bogie) => async (dispatch) => {
  try {
    const { data } = await api.createBogie(bogie);
    dispatch({ type: "ADD_BOGIE", payload: data });
  } catch (error) {
    console.error(error);
  }
};

export const editBogie = (id, bogie) => async (dispatch) => {
  try {
    const { data } = await api.updateBogie(id, bogie);
    dispatch({ type: "EDIT_BOGIE", payload: data });
  } catch (error) {
    console.error(error);
  }
};

export const removeBogie = (id) => async (dispatch) => {
  try {
    await api.deleteBogie(id);
    dispatch({ type: "DELETE_BOGIE", payload: id });
  } catch (error) {
    console.error(error);
  }
};

export const toggleBogieActive = (id) => async (dispatch) => {
  try {
    const { data } = await api.toggleBogieActive(id);
    dispatch({ type: "TOGGLE_BOGIE_ACTIVE", payload: data });
  } catch (error) {
    console.error(error);
  }
};